let projectGalleryBlocks = $('.wp-block-pulp-project-gallery');

if (projectGalleryBlocks.length) {
    projectGalleryBlocks.each(function () {

        let $this = $(this),
            blockId = $this.data('block-id'),
            filterOptions = $(this).find('.filter-option'),
            tabbedFilterOptions = $(this).find('.filters-container.is-style-tabs button'),
            filterOptionToggles = $(this).find('.filter-option-toggle'),
            mobileFilterToggle = $(this).find('.mobile-filters-toggle'),
            filtersContainer = $(this).find('.filters-container'),
            noResultsMessage = $(this).find('.no-results-message'),
            filtersCloseButton = $(this).find('.mobile-filters-done');

        function toggleMobileFilters() {
            if (window.outerWidth >= 992) {
                return;
            }
            if (mobileFilterToggle.hasClass('active')) {
                mobileFilterToggle.removeClass('active');
                filtersContainer.slideUp(200);
            } else {
                mobileFilterToggle.addClass('active');
                filtersContainer.slideDown(200);
            }
        }

        mobileFilterToggle.on('click', function (e) {
            e.preventDefault();
            toggleMobileFilters();
        });

        filtersCloseButton.on('click', function (e) {
            e.preventDefault();
            mobileFilterToggle.removeClass('active');
            filtersContainer.slideUp(200);
        });

        filterOptionToggles.on('click', function (e) {
            e.preventDefault();

            let filterOption = $(this).closest('.filter-option');

            if (filterOption.hasClass('active')) {
                filterOption.removeClass('active');
                filterOption.find('.filter-dropdown').slideUp();
            } else {
                filterOptions.not(filterOption).removeClass('active');
                filterOptions.not(filterOption).find('.filter-dropdown').slideUp();
                filterOption.addClass('active');
                filterOption.find('.filter-dropdown').slideDown();
            }
        });

        $('body').on('click', function (e) {
            if (!$(e.target).closest('.filter-option').length && !$(e.target).closest('.filter-option-toggle').length) {
                filterOptions.removeClass('active');
                filterOptions.find('.filter-dropdown').slideUp();
            }
        });

        filterOptions.find('input[type="checkbox"]').on('change', function () {
            projectGallerySearch();
        });

        filterOptions.find('input[type="radio"]').on('change', function () {
            projectGallerySearch();
        });

        filterOptions.find('button.filter-done').on('click', function (e) {
            e.preventDefault();
            let filterOption = $(this).closest('.filter-option');
            filterOption.removeClass('active');
            filterOption.find('.filter-dropdown').slideUp();
            projectGallerySearch();
        });

        tabbedFilterOptions.on('click', function (e) {
            e.preventDefault();
            tabbedFilterOptions.removeClass('active');
            $(this).addClass('active');
            projectGallerySearch();
            toggleMobileFilters();
        });

        filterOptions.find('.clear-filter-button').on('click', function (e) {
            let filterOption = $(this).closest('.filter-option'),
                inputs = filterOption.find('input[type="checkbox"], input[type="radio"]');

            e.preventDefault();
            e.stopPropagation();
            inputs.prop('checked', false);
            projectGallerySearch();
        });

        // galleryToggleButtons.on('click', function(e) {
        //     e.preventDefault();
        // });

        function projectGallerySearch() {

            let selectedPropertyTypes = [],
                selectedTypes = [],
                selectedLotTypes = [],
                selectedNeighborhoods = [],
                selectedBedrooms = [],
                selectedSizes = [],
                selectedBathrooms = [];

            processFilterLabels();

            $this.find('input[name="property-type"]:checked').each(function () {
                selectedPropertyTypes.push($(this).val());
            });

            $this.find('.filters-container.is-style-tabs .active').each(function () {
                if ($(this).data('value') !== 'all') {
                    selectedPropertyTypes.push($(this).data('value'));
                }
                if($(this).data('columns') === 4) {
                    $('.gallery-items-container').addClass('gallery-items-columns-4');
                } else {
                    $('.gallery-items-container').removeClass('gallery-items-columns-4');
                }
            });

            $this.find('input[name="type"]:checked').each(function () {
                selectedTypes.push($(this).val());
            });

            $this.find('input[name="lot-type"]:checked').each(function () {
                selectedLotTypes.push($(this).val());
            });

            $this.find('input[name="neighborhood"]:checked').each(function () {
                selectedNeighborhoods.push($(this).val());
            });

            $this.find('input[name="bedroom"]:checked').each(function () {
                selectedBedrooms.push($(this).val());
            });

            $this.find('input[name="bathroom"]:checked').each(function () {
                selectedBathrooms.push($(this).val());
            });

            $this.find('input[name="size"]:checked').each(function () {
                selectedSizes.push($(this).val());
            });

            window.project_gallery_projects.forEach(function (project) {

                let matchesAll = true;

                if (selectedPropertyTypes.length > 0) {
                    if (Array.isArray(project.property_type)) {
                        let matchesType = project.property_type.some(type => selectedPropertyTypes.includes(type));
                        if (!matchesType) matchesAll = false;
                    }
                }

                if (selectedTypes.length > 0) {
                    if (Array.isArray(project.type)) {
                        let matchesType = project.type.some(type => selectedTypes.includes(type));
                        if (!matchesType) matchesAll = false;
                    }
                }

                if (selectedLotTypes.length > 0) {
                    if (Array.isArray(project.lot_type)) {
                        let matchesLotType = project.lot_type.some(lot_type => selectedLotTypes.includes(lot_type));
                        if (!matchesLotType) matchesAll = false;
                    }
                }

                if (selectedNeighborhoods.length > 0) {
                    if (Array.isArray(project.neighborhood)) {
                        let matchesNeighborhood = project.neighborhood.some(neighborhood => selectedNeighborhoods.includes(neighborhood));
                        if (!matchesNeighborhood) matchesAll = false;
                    }
                }

                if (selectedBedrooms.length > 0) {
                    let matchesBedroom = selectedBedrooms.includes(project.bedrooms.toString());
                    if (!matchesBedroom) matchesAll = false;
                }

                if (selectedBathrooms.length > 0) {
                    let matchesBathroom = selectedBathrooms.includes(project.bathrooms.toString());
                    if (!matchesBathroom) matchesAll = false;
                }

                if (selectedSizes.length > 0) {
                    let matchesSizes = false;
                    selectedSizes.forEach(range => {
                        let lowerBound;
                        let upperBound;

                        if (range.includes('Under')) {
                            lowerBound = 0;
                            upperBound = Number(range.replace('Under ', '').replace(',', ''));
                        }

                        if (range.includes('+')) {
                            lowerBound = Number(range.replace('+', '').replace(',', ''));
                            upperBound = 99999999;
                        }

                        if (range.includes(' - ')) {
                            const arr = range.split(' - ');
                            lowerBound = Number(arr[0].replace(',', ''));
                            upperBound = Number(arr[1].replace(',', ''));
                        }

                        const size = Number(project.size);
                        if (size > lowerBound && size <= upperBound) {
                            matchesSizes = true;
                        }
                    });
                    if (!matchesSizes) matchesAll = false;
                }

                if (matchesAll) {
                    $('.gallery-item-' + project.id).removeClass('hidden');
                } else {
                    $('.gallery-item-' + project.id).addClass('hidden');
                }

                if ($('.gallery-item.hidden').length === $('.gallery-item').length) {
                    noResultsMessage.removeClass('hidden');
                } else {
                    noResultsMessage.addClass('hidden');
                }

            });

        }

        function processFilterLabels() {

            filterOptions.each(function () {

                let filterOption = $(this),
                    originalLabel = filterOption.data('original-label'),
                    label = filterOption.find('.filter-option-toggle').find('.label'),
                    options = filterOption.find('input[type="checkbox"]');

                let selectedOptions = options.filter(':checked'),
                    selectedCount = selectedOptions.length;

                if (selectedCount === 0) {
                    label.text(originalLabel);
                    filterOption.removeClass('has-selected');
                } else {
                    let labelText = '';
                    filterOption.addClass('has-selected');

                    if (selectedCount === 1) {
                        labelText = selectedOptions.first().val();
                    } else {
                        labelText = selectedOptions.first().val() + ', +' + (selectedCount - 1);
                    }
                    label.text(labelText);
                }
            });

        }

        projectGallerySearch();

    });
}
